<template>
  <div class="host">
    <slot />
  </div>
</template>

<script>
export default {
};
</script>

<style scoped>
.host {
  position: absolute;
  left: 2px;
  color: rgba(200, 0, 0, 0.9);
  font-size: 10px;
  font-weight: 300;
  line-height: 24px;
}
</style>
